





// function FieldError({ message }) {
//   if (!message) return null;
//   return <p className="text-red-500 text-[11px] mt-1">{message}</p>;
// }

// function inputCls(hasError) {
//   return `
//     flex-1 border px-3 py-2 text-sm text-gray-900 bg-white
//     focus:outline-none focus:ring-1
//     ${hasError ? "border-red-500 focus:ring-red-400" : "border-gray-400 focus:ring-blue-500"}
//   `;
// }

// function formatFileSize(bytes) {
//   if (bytes < 1024) return `${bytes} B`;
//   if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
//   return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
// }

// export default function QualityReviewSection({ form, errors = {}, setField, removeVoxFile }) {
//   const user = JSON.parse(
//   localStorage.getItem("user")
// );

//   return (
//     <div className="border border-gray-300 bg-[#dbe9f5] p-4">

//       {/* HEADER */}
//       <div className="mb-4 border-b border-cyan-500 pb-2">
//         <h3 className="text-sm font-bold uppercase text-gray-700">Quality Review</h3>
//         <p className="text-xs text-gray-500 mt-1">Only the quality team can edit this section</p>
//       </div>

//       <div className="space-y-3">

//         {/* EMAIL */}
//         <div className="flex items-start gap-3">
//           <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Email</label>
//           <div className="flex-1">
//             <input
//               name="email"
//               type="email"
//               value={form.email || ""}
//               onChange={setField("email")}
//               placeholder="Enter email"
//               className={inputCls(errors.email)}
//             />
//             <FieldError message={errors.email} />
//           </div>
//         </div>

//         {/* CALLBACK DATE */}
//         {form.leadDisposition === "Callback" && (
//           <div className="flex items-start gap-3">
//             <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">
//               Callback Date
//             </label>

//             <div className="flex-1">
//               <input
//                 name="callbackDate"
//                 type="datetime-local"
//                 value={form.callbackDate || ""}
//                 onChange={setField("callbackDate")}
//                 className={`
//                   w-full border px-3 py-2 text-sm bg-white text-gray-900
//                   focus:outline-none focus:ring-1
//                   ${
//                     errors.callbackDate
//                       ? "border-red-500 focus:ring-red-400"
//                       : "border-gray-400 focus:ring-blue-500"
//                   }
//                 `}
//               />

//               <FieldError message={errors.callbackDate} />
//             </div>
//           </div>
//         )}

//         {/* LEAD DISPOSITION */}
//         <div className="flex items-start gap-3">
//           <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Lead Disposition *</label>
//           <div className="flex-1">
//             <select
//               name="leadDisposition"
//               value={form.leadDisposition || ""}
//               onChange={setField("leadDisposition")}
//               className={`
//                 flex-1 w-full border px-3 py-2 text-sm text-gray-900 bg-white
//                 focus:outline-none focus:ring-1
//                 ${errors.leadDisposition ? "border-red-500 focus:ring-red-400" : "border-gray-400 focus:ring-blue-500"}
//               `}
//             >
//               <option value="">Select Disposition</option>
//               <option value="Quality">Quality</option>
//               <option value="Quality Low AQ">Quality Low AQ</option>
//               <option value="Quality OO">Quality 00</option>
//                <option value="Callback">Callback</option>
//                {(user?.role === "admin" || user?.role === "quality") && (
//   <>
//     <option value="Validate">Validate</option>
//     <option value="Validate Low AQ">Validate Low AQ</option>
//     <option value="Validate OO">Validate 00</option>
//     <option value="Hold">Hold</option>
//      <option value="Sold">Sold</option>
//     <option value="Reject">Reject</option>
    
//   </>
// )}
//             </select>
//             <FieldError message={errors.leadDisposition} />
//           </div>
//         </div>

//         {/* AGENT FEEDBACK */}
//         <div className="flex items-start gap-3">
//           <label className="w-44 pt-2 text-[12px] font-semibold text-gray-700">Agent Feedback</label>
//           <textarea
//             name="agentFeedback"
//             rows={5}
//             value={form.agentFeedback || ""}
//             onChange={setField("agentFeedback")}
//             placeholder="Enter agent feedback..."
//             className="flex-1 border border-gray-400 px-3 py-2 text-sm text-gray-900 bg-white resize-none focus:outline-none focus:ring-1 focus:ring-blue-500"
//           />
//         </div>

//         {/* QUALITY FEEDBACK */}
//         <div className="flex items-start gap-3">

//           <label className="w-44 pt-2 text-[12px] font-semibold text-gray-700">
//             Quality Feedback
//           </label>

//           <textarea
//             name="qualityFeedback"
//             rows={5}
//             value={form.qualityFeedback || ""}
//             onChange={setField("qualityFeedback")}
//             disabled={
//               user?.role !== "admin" &&
//               user?.role !== "quality"
//             }
//             placeholder="Quality team feedback..."
//             className={`
//               flex-1 border px-3 py-2 text-sm rounded-md resize-none
//               focus:outline-none focus:ring-1
//               ${
//                 user?.role === "admin" ||
//                 user?.role === "quality"
//                   ? "border-gray-400 bg-white text-gray-900 focus:ring-blue-500"
//                   : "border-gray-300 bg-gray-100 text-gray-500 cursor-not-allowed"
//               }
//             `}
//           />

//         </div>

       
//         {/* FILE UPLOAD — now supports multiple files */}
//        {/* FILE UPLOAD */}
// <div className="flex items-start gap-3">
//   <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Upload VOX Files</label>
//   <div className="flex-1">
//     <input
//       type="file"
//       accept=".vox,.mp3,.wav,.mp4,.ogg,.webm,.aac,.flac,.opus"
//       multiple
//       onChange={setField("voxFiles")}
//       className="w-full border border-gray-400 px-3 py-2 text-sm bg-white file:mr-3 file:px-3 file:py-1 file:border-0 file:bg-blue-600 file:text-white file:text-xs file:font-semibold"
//     />
//     <p className="text-[11px] text-gray-500 mt-1">
//       You can select multiple recordings — hold Ctrl (Windows) or Cmd (Mac) to pick more than one.
//     </p>

//     {/* SELECTED FILES LIST WITH PREVIEW PLAYER */}
//     {form.voxFiles && form.voxFiles.length > 0 && (
//       <ul className="mt-2 space-y-2">
//         {form.voxFiles.map((file, index) => {

//           // create a temporary blob URL for in-browser playback
//           const previewUrl = URL.createObjectURL(file);

//           return (
//             <li
//               key={`${file.name}-${index}`}
//               className="bg-white border border-gray-300 rounded px-3 py-2 text-xs"
//             >
//               {/* FILE NAME + REMOVE */}
//               <div className="flex items-center justify-between mb-2">
//                 <span className="text-gray-700 truncate pr-2 font-medium">
//                   🎵 {file.name}{" "}
//                   <span className="text-gray-400 font-normal">
//                     ({formatFileSize(file.size)})
//                   </span>
//                 </span>
//                 <button
//                   type="button"
//                   onClick={() => removeVoxFile(index)}
//                   className="text-red-500 hover:text-red-700 font-semibold shrink-0 ml-2"
//                 >
//                   Remove
//                 </button>
//               </div>

//               {/* AUDIO PREVIEW PLAYER */}
//               <audio
//                 controls
//                 preload="metadata"
//                 className="w-full h-8"
//                 src={previewUrl}
//                 onLoadedData={() => {
//                   // revoke after load to free memory
//                   // small timeout ensures browser has read it
//                   setTimeout(() => URL.revokeObjectURL(previewUrl), 10000);
//                 }}
//               />
//             </li>
//           );
//         })}
//       </ul>
//     )}
//   </div>
// </div>

//       </div>
//     </div>
//   );
// }





function FieldError({ message }) {
  if (!message) return null;
  return <p className="text-red-500 text-[11px] mt-1">{message}</p>;
}

function inputCls(hasError) {
  return `
    flex-1 border px-3 py-2 text-sm text-gray-900 bg-white
    focus:outline-none focus:ring-1
    ${hasError ? "border-red-500 focus:ring-red-400" : "border-gray-400 focus:ring-blue-500"}
  `;
}


function getFileIcon(fileName) {
  const ext = fileName.split(".").pop().toLowerCase();
  if (ext === "png") return "🖼️";
  if (ext === "pdf") return "📄";
  if (ext === "doc" || ext === "docx") return "📝";
  return "📎";
}

function formatFileSize(bytes) {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default function QualityReviewSection({ form, errors = {}, setField, removeVoxFile, removeAttachment }) {
  const user = JSON.parse(
  localStorage.getItem("user")
);

  return (
    <div className="border border-gray-300 bg-[#dbe9f5] p-4">

      {/* HEADER */}
      <div className="mb-4 border-b border-cyan-500 pb-2">
        <h3 className="text-sm font-bold uppercase text-gray-700">Quality Review</h3>
        <p className="text-xs text-gray-500 mt-1">Only the quality team can edit this section</p>
      </div>

      <div className="space-y-3">

        {/* EMAIL */}
        <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Email</label>
          <div className="flex-1">
            <input
              name="email"
              type="email"
              value={form.email || ""}
              onChange={setField("email")}
              placeholder="Enter email"
              className={inputCls(errors.email)}
            />
            <FieldError message={errors.email} />
          </div>
        </div>

        {/* CALLBACK DATE */}
        {form.leadDisposition === "Callback" && (
          <div className="flex items-start gap-3">
            <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">
              Callback Date
            </label>

            <div className="flex-1">
              <input
                name="callbackDate"
                type="datetime-local"
                value={form.callbackDate || ""}
                onChange={setField("callbackDate")}
                className={`
                  w-full border px-3 py-2 text-sm bg-white text-gray-900
                  focus:outline-none focus:ring-1
                  ${
                    errors.callbackDate
                      ? "border-red-500 focus:ring-red-400"
                      : "border-gray-400 focus:ring-blue-500"
                  }
                `}
              />

              <FieldError message={errors.callbackDate} />
            </div>
          </div>
        )}

        {/* LEAD DISPOSITION */}
        <div className="flex items-start gap-3">
          <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Lead Disposition *</label>
          <div className="flex-1">
            <select
              name="leadDisposition"
              value={form.leadDisposition || ""}
              onChange={setField("leadDisposition")}
              className={`
                flex-1 w-full border px-3 py-2 text-sm text-gray-900 bg-white
                focus:outline-none focus:ring-1
                ${errors.leadDisposition ? "border-red-500 focus:ring-red-400" : "border-gray-400 focus:ring-blue-500"}
              `}
            >
              <option value="">Select Disposition</option>
              <option value="Quality">Quality</option>
              <option value="Quality Low AQ">Quality Low AQ</option>
              <option value="Quality OO">Quality 00</option>
               <option value="Callback">Callback</option>
               {(user?.role === "admin" || user?.role === "quality") && (
  <>
    <option value="Validate">Validate</option>
    <option value="Validate Low AQ">Validate Low AQ</option>
    <option value="Validate OO">Validate 00</option>
    <option value="Hold">Hold</option>
     <option value="Sold">Sold</option>
    <option value="Reject">Reject</option>
    
  </>
)}
            </select>
            <FieldError message={errors.leadDisposition} />
          </div>
        </div>

        {/* AGENT FEEDBACK */}
        <div className="flex items-start gap-3">
          <label className="w-44 pt-2 text-[12px] font-semibold text-gray-700">Agent Feedback</label>
          <textarea
            name="agentFeedback"
            rows={5}
            value={form.agentFeedback || ""}
            onChange={setField("agentFeedback")}
            placeholder="Enter agent feedback..."
            className="flex-1 border border-gray-400 px-3 py-2 text-sm text-gray-900 bg-white resize-none focus:outline-none focus:ring-1 focus:ring-blue-500"
          />
        </div>

        {/* QUALITY FEEDBACK */}
        <div className="flex items-start gap-3">

          <label className="w-44 pt-2 text-[12px] font-semibold text-gray-700">
            Quality Feedback
          </label>

          <textarea
            name="qualityFeedback"
            rows={5}
            value={form.qualityFeedback || ""}
            onChange={setField("qualityFeedback")}
            disabled={
              user?.role !== "admin" &&
              user?.role !== "quality"
            }
            placeholder="Quality team feedback..."
            className={`
              flex-1 border px-3 py-2 text-sm rounded-md resize-none
              focus:outline-none focus:ring-1
              ${
                user?.role === "admin" ||
                user?.role === "quality"
                  ? "border-gray-400 bg-white text-gray-900 focus:ring-blue-500"
                  : "border-gray-300 bg-gray-100 text-gray-500 cursor-not-allowed"
              }
            `}
          />

        </div>

       
        {/* FILE UPLOAD — now supports multiple files */}
       {/* FILE UPLOAD */}
<div className="flex items-start gap-3">
  <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Upload VOX Files</label>
  <div className="flex-1">
    <input
      type="file"
      accept=".vox,.mp3,.wav,.mp4,.ogg,.webm,.aac,.flac,.opus"
      multiple
      onChange={setField("voxFiles")}
      className="w-full border border-gray-400 px-3 py-2 text-sm bg-white file:mr-3 file:px-3 file:py-1 file:border-0 file:bg-blue-600 file:text-white file:text-xs file:font-semibold"
    />
    <p className="text-[11px] text-gray-500 mt-1">
      You can select multiple recordings — hold Ctrl (Windows) or Cmd (Mac) to pick more than one.
    </p>

    {/* SELECTED FILES LIST WITH PREVIEW PLAYER */}
    {form.voxFiles && form.voxFiles.length > 0 && (
      <ul className="mt-2 space-y-2">
        {form.voxFiles.map((file, index) => {

          // create a temporary blob URL for in-browser playback
          const previewUrl = URL.createObjectURL(file);

          return (
            <li
              key={`${file.name}-${index}`}
              className="bg-white border border-gray-300 rounded px-3 py-2 text-xs"
            >
              {/* FILE NAME + REMOVE */}
              <div className="flex items-center justify-between mb-2">
                <span className="text-gray-700 truncate pr-2 font-medium">
                  🎵 {file.name}{" "}
                  <span className="text-gray-400 font-normal">
                    ({formatFileSize(file.size)})
                  </span>
                </span>
                <button
                  type="button"
                  onClick={() => removeVoxFile(index)}
                  className="text-red-500 hover:text-red-700 font-semibold shrink-0 ml-2"
                >
                  Remove
                </button>
              </div>

              {/* AUDIO PREVIEW PLAYER */}
              <audio
                controls
                preload="metadata"
                className="w-full h-8"
                src={previewUrl}
                onLoadedData={() => {
                  // revoke after load to free memory
                  // small timeout ensures browser has read it
                  setTimeout(() => URL.revokeObjectURL(previewUrl), 10000);
                }}
              />
            </li>
          );
        })}
      </ul>
    )}
  </div>
</div>


 {/* ── DOCUMENT UPLOAD — PNG / PDF / Word ──────────  ← NEW */}
      <div className="flex items-start gap-3">
        <label className="w-44 text-[12px] font-semibold text-gray-700 pt-2">Upload Attachments</label>
        <div className="flex-1">
          <input
            type="file"
            accept=".png,image/png,.pdf,application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            multiple
            onChange={setField("attachments")}
            className="w-full border border-gray-400 px-3 py-2 text-sm bg-white file:mr-3 file:px-3 file:py-1 file:border-0 file:bg-blue-600 file:text-white file:text-xs file:font-semibold"
          />
          <p className="text-[11px] text-gray-500 mt-1">
            Accepted formats: PNG, PDF, Word (.doc/.docx). Hold Ctrl/Cmd to select multiple.
          </p>

          {/* SELECTED ATTACHMENTS LIST */}
          {form.attachments && form.attachments.length > 0 && (
            <ul className="mt-2 space-y-2">
              {form.attachments.map((file, index) => (
                <li
                  key={`${file.name}-${index}`}
                  className="bg-white border border-gray-300 rounded px-3 py-2 text-xs flex items-center justify-between"
                >
                  <span className="text-gray-700 truncate pr-2 font-medium">
                    {getFileIcon(file.name)} {file.name}{" "}
                    <span className="text-gray-400 font-normal">
                      ({formatFileSize(file.size)})
                    </span>
                  </span>
                  <button
                    type="button"
                    onClick={() => removeAttachment(index)}
                    className="text-red-500 hover:text-red-700 font-semibold shrink-0 ml-2"
                  >
                    Remove
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>






      </div>
    </div>
  );
}